/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * メールテンプレート種別
 * @export
 */
export const MailTemplateType = {
    TenantInvitation: 'tenantInvitation',
    InitialPassword: 'initialPassword'
} as const;
export type MailTemplateType = typeof MailTemplateType[keyof typeof MailTemplateType];


export function instanceOfMailTemplateType(value: any): boolean {
    for (const key in MailTemplateType) {
        if (Object.prototype.hasOwnProperty.call(MailTemplateType, key)) {
            if (MailTemplateType[key as keyof typeof MailTemplateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailTemplateTypeFromJSON(json: any): MailTemplateType {
    return MailTemplateTypeFromJSONTyped(json, false);
}

export function MailTemplateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailTemplateType {
    return json as MailTemplateType;
}

export function MailTemplateTypeToJSON(value?: MailTemplateType | null): any {
    return value as any;
}

export function MailTemplateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MailTemplateType {
    return value as MailTemplateType;
}

